module.exports = __webpack_public_path__ + "static/media/shield-tick-security-svgrepo-com.c1dd0d89.svg";